/**
 * 浏览器标志
 * @returns {boolean} 移动端/pc端
 */
export function browserFlag() {
  var sUserAgent = navigator.userAgent.toLowerCase();
  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
    //移动端页面
    return true
  } else {
    //pc端页面
    return false
  }
}
